export const getFilenameWithExtensionFromUrl = url => {
  if (!url) {
    return ''
  }

  const [file] = url
    .replaceAll(' ', '')
    .split('/')
    .pop()
    .match(/[\w,\s-()]+\.[A-Za-z]{3}/)

  return file || ''
}

export const imageExtension = /(\.jpg|\.jpeg|\.png|\.gif)$/i

export const emailPlaceholderRegex = /\{{(.*?)\}}/g

export const escapeRegExp = text => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
